import { flattenValues } from "@uniformdev/canvas";
import { UniformCustomerQuote } from "src/uniform/contenttypes/customerQuote";
import { UniformCustomerStat } from "src/uniform/contenttypes/customerStat";

import {
    GalleryContainer,
    CustomerQuote,
    CustomerStat
} from "@/libraries/design/components";

export interface UniformCustomerGalleryProps {
    items: (UniformCustomerQuote | UniformCustomerStat)[];
    isMotionAvailable?: boolean;
}

const UniformCustomerGallery = ({
    items,
    isMotionAvailable
}: UniformCustomerGalleryProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedItems = flattenValues(items as any) as (
        | UniformCustomerQuote
        | UniformCustomerStat
    )[];
    return (
        <GalleryContainer isMotionAvailable={isMotionAvailable}>
            {/* eslint-disable-next-line complexity */}
            {flattenedItems.map((item, index) => {
                if (item) {
                    if ("quote" in item) {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-ignore
                                    "--gc-item-i": index
                                }}
                            >
                                <CustomerQuote
                                    logoSrc={item.companyLogo?.at(0)?.src ?? ""}
                                    logoAlt={item.companyLogo?.at(0)?.alt ?? ""}
                                    name={item.advocateName ?? ""}
                                    title={item.advocateJobTitle ?? ""}
                                    company={item.companyName ?? ""}
                                    quote={item.quote ?? ""}
                                    ctaLinkText={item.ctaLinkText}
                                    ctaLinkUrl={item.ctaUrl}
                                    imageSrc={
                                        item.advocateHeadshot?.at(0)?.src ?? ""
                                    }
                                    imageAlt={item.advocateHeadshot?.at(0)?.alt}
                                    color={item.color}
                                />
                            </div>
                        );
                    } else if ("statNumber" in item) {
                        return (
                            <div
                                key={index}
                                className="entry-item"
                                style={{
                                    // @ts-ignore
                                    "--gc-item-i": index
                                }}
                            >
                                <CustomerStat
                                    logoSrc={item.logo?.at(0)?.src ?? ""}
                                    logoAlt={item.logo?.at(0)?.alt ?? ""}
                                    statValue={
                                        item.statNumber?.toString() ?? ""
                                    }
                                    statModifier={item.statModifier}
                                    description={item.description ?? ""}
                                    linkText={item.ctaText}
                                    linkHref={item.ctaUrl}
                                    color={item.color}
                                />
                            </div>
                        );
                    }
                }
            })}
        </GalleryContainer>
    );
};

export default UniformCustomerGallery;
